/**
 * Admin "login as" — joriy tokenlarni zaxiralab, keyin maqsad foydalanuvchi tokenlariga almashtirish.
 * Ortga qaytishda zaxira tiklanadi.
 */

import { getStoredRefreshToken, getStoredToken } from '../services/authApi';

const BACKUP_KEY = 'addesite_admin_impersonation_backup_v1';

export interface AdminImpersonationBackup {
  accessToken: string;
  refreshToken: string | null;
  /** JSON.stringify(User) */
  userSnapshot: string;
}

export function readAdminImpersonationBackup(): AdminImpersonationBackup | null {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage?.getItem(BACKUP_KEY) : null;
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<AdminImpersonationBackup>;
    if (!p?.accessToken || !p?.userSnapshot) return null;
    return {
      accessToken: p.accessToken,
      refreshToken: p.refreshToken ?? null,
      userSnapshot: p.userSnapshot,
    };
  } catch {
    return null;
  }
}

/**
 * Maqsad foydalanuvchi tokenlari qo‘yilishidan oldin chaqiriladi.
 * Ichki "login as" (zaxira allaqachon bor) yoki token/snapshot yo‘q bo‘lsa — false.
 */
export function saveAdminImpersonationBackup(): boolean {
  try {
    if (readAdminImpersonationBackup()) return false;
    const accessToken = getStoredToken();
    const refreshToken = getStoredRefreshToken();
    const userSnapshot = typeof window !== 'undefined' ? window.localStorage?.getItem('adminUser') : null;
    if (!accessToken || !userSnapshot) return false;
    const payload: AdminImpersonationBackup = {
      accessToken,
      refreshToken,
      userSnapshot,
    };
    window.localStorage?.setItem(BACKUP_KEY, JSON.stringify(payload));
    return true;
  } catch {
    return false;
  }
}

export function clearAdminImpersonationBackup(): void {
  try {
    window.localStorage?.removeItem(BACKUP_KEY);
  } catch {}
}

export function isAdminImpersonationActive(): boolean {
  return readAdminImpersonationBackup() != null;
}
